module.exports = __webpack_public_path__ + "img/intro.514330ae.png";